
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M10.5 17.15L14.48 14.87C15.15 14.49 15.15 13.52 14.48 13.13L10.5 10.85C9.83 10.47 9 10.96 9 11.72V16.27C9 17.04 9.83 17.53 10.5 17.15ZM21 6.00001H13.41L16.35 3.06001C16.55 2.86001 16.55 2.55001 16.35 2.35001C16.15 2.15001 15.84 2.15001 15.64 2.35001L12 5.99001L8.36 2.35001C8.16 2.15001 7.85 2.15001 7.65 2.35001C7.45 2.55001 7.45 2.86001 7.65 3.06001L10.59 6.00001H3C1.9 6.00001 1 6.89001 1 8.00001V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V8.00001C23 6.89001 22.1 6.00001 21 6.00001ZM20 20H4C3.45 20 3 19.55 3 19V9.00001C3 8.45001 3.45 8.00001 4 8.00001H20C20.55 8.00001 21 8.45001 21 9.00001V19C21 19.55 20.55 20 20 20Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-live-tv`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLiveTv

    ```js
    <b-new-b-icon-live-tv />
    ```
</docs>


